import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import FormikActions from "../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../commons/formik/FormikAutocomplete";
import FormikTextField from "../../../commons/formik/FormikTextField";
import { StyledDatosComprobante } from "../../../styled/Reintegros";
import { rubrosDelReintegroValidation } from "../../validation/formValidation";

const initialValuesRubros = {
  rubro: "",
  importe: "",
  id: "",
  nombre: "",
};

const AddComprobanteDialog = ({
  open,
  onEdit,
  model,
  handleSubmit,
  handleCloseAddDialog,
}) => {

  const rubrosReintegro = useSelector(
    (state) => state.reintegros.rubrosReintegro
  );

  return (
    <Dialog open={open}>
      <DialogTitle variant="h6" align="center" style={{ padding: 10 }}>
        Rubros del Reintegro
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={onEdit ? model : initialValuesRubros}
          onSubmit={handleSubmit}
          validationSchema={rubrosDelReintegroValidation}
        >
          {({ setFieldValue }) => (
            <Form>
              <StyledDatosComprobante.GridContainer container spacing={2}>
                <StyledDatosComprobante.DialogInputContainer item xs={12}>
                  <FormikAutocomplete
                    fullWidth
                    name="rubro"
                    label="Rubros"
                    variant="standard"
                    options={rubrosReintegro.data}
                    renderOption={(option) => option.nombre}
                    filterOptions={(option) => option.nombre}
                    callBack={(inputValue) => {
                      if (inputValue) {
                        setFieldValue("nombre", inputValue.nombre);
                      }
                    }}
                  />
                </StyledDatosComprobante.DialogInputContainer>
                <StyledDatosComprobante.DialogInputContainer item xs={12}>
                  <FormikTextField
                    fullWidth
                    id="importe"
                    name="importe"
                    type="text"
                    label="Importe"
                  />
                </StyledDatosComprobante.DialogInputContainer>
                <StyledDatosComprobante.DialogButtonContainer item xs={12}>
                  <FormikActions
                    submit="Agregar"
                    handleCancel={handleCloseAddDialog}
                  />
                </StyledDatosComprobante.DialogButtonContainer>
              </StyledDatosComprobante.GridContainer>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default AddComprobanteDialog;
